<section class="gap-64 md-gap-16 flex">
  <section class="flex-col">
    <h1 class="heading-1 mb-24 md-mb-12">We couldn’t find an engineer in your area</h1>

    <section class="flex-col gap-16 mb-32 md-mb-24">
      <p class="body large">
        Unfortunately, we are unable to find an available engineer. But don’t worry - you can continue with your repair
        booking over the phone
      </p>

      <section class="flex-col gap-16 md-gap-8">
        <p class="body large">Give us a call on:</p>
        <app-telephone-link [phoneNumber]="vm.phoneNumber" [largeFont]="true" />
      </section>

      <section class="flex-col gap-16 md-gap-8">
        <p class="hint">
          Calls cost the standard UK landline rate. Lines open Mon-Fri 8am-6pm, Sat 8:30am-4:30pm, Sun 9:30am-3:30pm.
        </p>
      </section>
    </section>

    <app-button
      dataLabel="no-engineer-available-repair-page-link"
      [buttonOptions]="{
        isLink: true,
        url: vm.repairsPageUrl,
      }"
    >
      <i class="fa-light fa-arrow-left mr-8"></i>
      Back to repairs page
    </app-button>

    <p class="hint mt-32 md-mt-24">Error code: {{ vm.errorSource }}: No Availability Error</p>
  </section>

  <section>
    <img src="/assets/images/no-engineer-available.png" alt="No engineer available illustration" />
  </section>
</section>
